import * as React from 'react';
import { Button, Spin } from 'antd';
import autobind from 'autobind-decorator';

import CheckoutGateway from './parts/checkout';
import SagepayGateway from './parts/sagepay';
import PaysafeGateway from './parts/paysafe';

interface Props {
	onAuthorizePayment: (t, serviceName: string, extra?: { [id: string]: any }) => void;
	service: IServiceInfo;
	cardHolder: string;
}

interface State {
	loadingSession: boolean;
	errors?: string;
	token: string;
	loading: boolean;
	loadingError: boolean;
	loadedScripts: string[];
	requiredScriptsCount: number;
}

export default class GatewayComponent extends React.Component<Props, State> {

	constructor(props: Readonly<Props>) {
		super(props);

		this.state = {
			loadingSession: false,
			loading: false,
			token: '',
			loadingError: false,
			loadedScripts: [],
			requiredScriptsCount: 0
		};
	}

	componentWillUnmount(): void {
		this.removeScriptFromBody();
	}

	@autobind
	private getGatewayComponent(service: IServiceInfo): React.ReactNode {
		const payBtn = (
			<Button type="primary" style={{ marginTop: '20px' }} htmlType='submit'>{"Pay now"}</Button>
		);

		const props: GatewayProps = {
			onMount: this.addScriptsToBody,
			onTokenReceive: (t: string, paymentGatewayName: string, extra?: { [id: string]: any }) => {
				this.setState({ token: t }, () => this.authorize(paymentGatewayName, extra))
			},
			payComponent: payBtn,
			gateway: service,
            errors: this.state.errors,
            cardHolder: this.props.cardHolder,
		}

		switch (service.paymentGatewayName) {
			case 'Checkout':
				return <CheckoutGateway {...props} />;

			case 'SagePay':
				return <SagepayGateway {...props} />;

			case 'Paysafe':
				return <PaysafeGateway {...props} />;
		}

		return (
			<h4>There is no component for {name} service</h4>
		);
	}

	removeScriptFromBody = (): void => {
		for (var url of this.state.loadedScripts) {

			var element = document.querySelector(`script[src='${url}']`);

			if (element) {
				document.body.removeChild(element);
			}
		}

		this.setState({
			loadedScripts: []
		});
	}

	addScriptsToBody = (cb: () => void, scriptUrls: string[]) => {
		this.setState({ loading: true, requiredScriptsCount: scriptUrls.length })		

		for (var url of scriptUrls) {

			var element = document.querySelector(`script[src='${url}']`);

			if (element) {
				this.updateLoadedScriptsState(url, cb);
				continue;
			}

			const script = document.createElement('script');
			script.src = url;
			script.async = false;

			script.addEventListener('load', () => {
				this.setState({ loading: false })
				this.updateLoadedScriptsState(url, cb);
			});

			script.addEventListener('error', () => {
				this.setState({ loadingError: true });
			});

			document.body.appendChild(script);
		}
	}

	updateLoadedScriptsState = (url: string, cb:() => void) => {
		this.setState({
			loadedScripts: [...this.state.loadedScripts, url]
		},
		() => {
			if (this.state.loadedScripts.length == this.state.requiredScriptsCount) {
				// All scripts successfully loaded
				// call callback function to notify the component
				cb();		
			}
		});
	}

	authorize = async (paymentGatewayName: string, extra?: {[id:string]: any}) => {

		if (this.state.loading)
			return;

		this.setState({ loading: true, errors: undefined });

		const { token } = this.state;

		try {
			this.props.onAuthorizePayment(token, paymentGatewayName, extra);
		}
		catch (e) {
			console.log(e);
			this.parseExceptions(e);
		}
		finally {
			this.setState({ loading: false });
		}
	}

	parseExceptions(e: any) {
		try {
			const result = JSON.parse(e.response.data.exceptionMessage);
			this.setState({ errors: result });
		}
		catch (e) {
			console.log(e);
		}
	}

	render(): React.ReactNode {
		if (this.state.loadingError) {
			return (
				<h3 style={{ color: 'red' }}>Loading external script fail</h3>
			);
		}

		return (
			<React.Fragment>
				<Spin spinning={this.state.loading || !this.props.service} size="large"
					className="mt-3" wrapperClassName="mt-3" style={{ minWidth: '50px', minHeight: '50px' }}>
					<div style={{ display: this.state.loading ? 'none' : 'initial' }} >
						{this.props.service &&
							this.getGatewayComponent(this.props.service)
						}
					</div>

				</Spin>
			</React.Fragment>
		);
	}

}



// WEBPACK FOOTER //
// ./src/app/accounting/payment-gateway/gateway-component.tsx